import { css } from "styled-components";

export const variables = css`
  :root {
    --primary: #fa8232;
    --secondary: #1b6392;
    --title: #191c1f;
    --titleSecondary: #2484c2;
    --text: #475156;
    --textSecondary: #fff;
    --textThird: #5f6c72;
    --disabled: #929fa5;
    --disabledSecondary: #e4e7e9;
    --price: #2da5f3;
    --warning: #ebc80c;
    --warningSecondary: #f7e99e;
    --danger: #ee5858;
    --ok: #2db324;
  }
`;
